import { BrowserCacheLocation, IPublicClientApplication, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MsalGuardConfiguration } from '@azure/msal-angular';

export const TAI_API_SCOPES = ['https://teaditbr.onmicrosoft.com/taiapi/read'];

export function msalInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: 'd13dbc97-2b1a-406c-aae8-ce274e2dfa74',
      authority: 'https://login.microsoftonline.com/da688131-c2d2-46de-8a7f-6d130551ed54',
      redirectUri: `${window.location.origin}/chat`,
      postLogoutRedirectUri: `${window.location.origin}/login`,
    },
    cache: { cacheLocation: BrowserCacheLocation.LocalStorage },
  });
}

export function msalGuardConfigFactory(): MsalGuardConfiguration {
  return { interactionType: InteractionType.Redirect, authRequest: { scopes: TAI_API_SCOPES }, loginFailedRoute: '/login' };
}
